<template>
  <div id="app">
    <Navigation v-if="!$route.meta.routerView" />
    <Aside v-if="!$route.meta.routerView" />
    <div class="container" :class="{ 'routerView': $route.meta.routerView }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation"
import Aside from "@/components/Aside"
export default {
  components: { Navigation, Aside },
  name: 'App',
  created() {
    console.log(this.$route)
  }
}
</script>

<style lang="scss" scoped>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  background: #eee;
  min-width: 1280px;

  .container {
    position: absolute;
    top: 70px;
    left: 320px;
    right: 20px;
    bottom: 20px;
    overflow: auto;
  }

  .routerView {
    top: 0;
    left: 0;
    right: 0;
  }
}
</style>
